<script>
  import Th from "../Tables/Th.svelte";
  import ThFilter from "../Tables/ThFilter.svelte";
  import RowsPerPage from "../Tables/RowsPerPage.svelte";
  import RowCount from "../Tables/RowCount.svelte";
  import Pagination from "../Tables/Pagination.svelte";
  import { DataHandler } from "@vincjo/datatables";
  //import { sortedJsonData } from "../Tables/tableData";
  import {
    selectedDeviceId,
    selectedDevices,
    selectedPage,
    selectorAppId,
    selectorConfig,
    selectorClient,
    selectorDate,
    selectorDeviceId,
    selectorFirmware,
    selectorMobileId,
    selectorScript,
    tableData,
    selectorCarrier
  } from "../store";
  import { downloadCSV } from "../Utils.svelte";
  import { onMount, afterUpdate } from "svelte";
  import { each, listen } from "svelte/internal";

  //var $tableData = sortedJsonData();

  const handler = new DataHandler($tableData, { rowsPerPage: 15 });
  let rows = handler.getRows();
  const selected = handler.getSelected();
  const isAllSelected = handler.isAllSelected();
  let disabled;
  let isMounted = false;
  let selectedMemory = [];
  let filter_id_device;
  let allowedData = [
    "id_device",
    "carrier",
    "script",
    "config",
    "app",
    "ota_status",
    "ota_dialog",
    "app_id",
    "date",
    "company"
  ];
  // Mantener el número de página anterior
  const currentPage = handler.getPageNumber(); // Página actual
  let currSelectedPage = 0; // Página seleccionada
  let previousPage = 0;
  let selectedRowIds = [];
  let totalSelectedRowIds = [];
  let selectedPageRowIds = [];
  const rowsPerPage = handler.getRows();
  let isMasterCheckboxSelected = false;
  //let isMasterCheckboxSelected = false; // Estado del checkbox maestro en la página actual
  $: $currentPage, handlePageChange();
  $: $selected, handlePageChange();

  function selectAllRowsInPage() {
    if (isMasterCheckboxSelected) {
      //Unselect all
      $rowsPerPage.forEach((row) => {
        if ($selected.includes(row.id_device)) {
          handler.select(row.id_device);
        }
      });
    } else {
      $rowsPerPage.forEach((row) => {
        //Select all
        if (!$selected.includes(row.id_device)) {
          handler.select(row.id_device);
        }
      });
    }
  }

  function checkMasterCheckboxSelected() {
    isMasterCheckboxSelected = true;
    $rowsPerPage.forEach((row) => {
      if (!$selected.includes(row.id_device)) {
        isMasterCheckboxSelected = false;
      }
    });
    //return handler.isAllSelected();
  }

  function handlePageChange() {
    /*console.log("Selected", $selected);
    console.log("Rows", $rowsPerPage);*/

    /* selectedRowIds = [];
    $rowsPerPage.forEach((row) => {
      if ($selected.includes(row.id_device)) {
        selectedRowIds.push(row.id_device);
      }
    });*/
    // Guarda los identificadores de las filas seleccionadas en la página actual
    //selectedRowIds = $selected;
    //totalSelectedRowIds.concat(selectedRowIds);
    //console.log("SelectedRowsId", selectedRowIds);
    //console.log("TotalSelectedRowsId", totalSelectedRowIds);

    previousPage = currSelectedPage;
    currSelectedPage = $currentPage;

    checkMasterCheckboxSelected();

    //console.log("Previous", previousPage);
    //console.log("Current", currSelectedPage);

    /*if (currSelectedPage === previousPage) {
      // La página se mantuvo igual, no hagas nada
    } else {
      // La página cambió a una nueva página
      isMasterCheckboxSelected = false;

      // Restaura la selección en la nueva página
      handler.select(...totalSelectedRowIds);
    }*/
  }

  function selectAllOnCurrentPage() {
    handler.selectAll({ selectBy: "id_device", scope: "currentPage" });
    //isMasterCheckboxSelected = handler.isAllSelected();
  }

  //$: $selectedDeviceId, console.log($selectedDeviceId); //DeviceDetail

  $: $selected, switchEnable();

  $: $selectorDeviceId, filterDevice();

  function filterDevice() {
    console.log($selectorDeviceId);
    if (isMounted) {
      filter_id_device = document.getElementById("filter_id_device");
      filter_id_device.addEventListener("input", updateSelectorDeviceId);
      filter_id_device.value = $selectorDeviceId;
      filter_id_device.dispatchEvent(new Event("input"));
    }
  }

  function updateSelectorDeviceId(e) {
    console.log(e.target.value);
    selectorDeviceId.set(e.target.value);
  }

  function switchEnable() {
    //console.log($selected);
    /*if ($selected.length >= 1) {
      selectedMemory = $selected;
    }*/
    //console.log(selectedMemory);
    disabled = $selected.length == 0 ? true : false;
  }

  /*function validateCheckBox(id_device){
    if (!$selected.includes(id_device)) {
      handler.select(id_device)
    }
  }

  function checkIfChecked(id_device){
    let inList = false
    if ($selected.includes(id_device) || selectedMemory.includes(id_device))  {
      inList = true
    }

    return inList
  }*/

  function passDevices() {
    let devices = [];
    $tableData.forEach((device) => {
      if ($selected.includes(device.id_device)) {
        devices.push(device);
      }
    });
    selectedDevices.set(devices);
    console.log($selectedDevices);
  }

  onMount(async () => {
    disabled = true;

    let filter_id_device = document.getElementById("filter_id_device");
    filter_id_device.value = $selectorDeviceId;
    filter_id_device.dispatchEvent(new Event("input"));

    let filter_date = document.getElementById("filter_date");
    filter_date.value = $selectorDate;
    filter_date.dispatchEvent(new Event("input"));

    let filter_config = document.getElementById("filter_config");
    filter_config.value = $selectorConfig;
    filter_config.dispatchEvent(new Event("input"));

    let filter_company = document.getElementById("filter_company");
    filter_company.value = $selectorClient;
    filter_company.dispatchEvent(new Event("input"));

    let filter_script = document.getElementById("filter_script");
    filter_script.value = $selectorScript;
    filter_script.dispatchEvent(new Event("input"));

    let filter_app_id = document.getElementById("filter_app_id");
    filter_app_id.value = $selectorAppId;
    filter_app_id.dispatchEvent(new Event("input"));

    let filter_firmware = document.getElementById("filter_app");
    filter_firmware.value = $selectorFirmware;
    filter_firmware.dispatchEvent(new Event("input"));

    let filter_carrier = document.getElementById("filter_carrier");
    filter_carrier.value = $selectorCarrier;
    filter_carrier.dispatchEvent(new Event("input"));

    let filter_ota_status = document.getElementById("filter_ota_status");
    //filter_ota_status.value = $selectorOtaStatus;
    filter_ota_status.dispatchEvent(new Event("input"));

    let filter_ota_dialog = document.getElementById("filter_ota_dialog");
    //filter_ota_dialog.value = $selectorOtaDialog;
    filter_ota_dialog.dispatchEvent(new Event("input"));

    if (selectedRowIds.length > 0) {
      // Restaura la selección en la página actual
      handler.select(selectedRowIds);
    }

    isMounted = true;
  });
</script>

<hr />

<div class="row">
  <div class="col-lg-6">
    <h2>Group</h2>
  </div>
  <div class="col-lg-6">
    <div class="d-flex justify-content-end">
      <div style="margin-top: 4px;">
        <RowsPerPage {handler} />
      </div>

      <button
        {disabled}
        id="btn-task"
        type="button"
        class="btn btn-primary"
        style="margin-left:16px"
        on:click={() => {
          passDevices();
          selectedPage.set(10);
        }}
      >
        <i class="bi bi-list-ol"></i> Tasks</button
      >

      <!--<button
        {disabled}
        id="btn-config"
        type="button"
        class="btn btn-primary"
        style="margin-left:16px"
        on:click={() => {
          passDevices();
          selectedPage.set(7);
        }}
      >
        <i class="bi bi-gear-fill" /> Config</button
      >

      <button
        {disabled}
        id="btn-group-firmware"
        type="button"
        class="btn btn-secondary"
        style="margin-left:16px"
        on:click={() => {
          passDevices();
          selectedPage.set(2);
        }}
      >
        <i class="bi bi-cpu-fill" /> Firmware</button
      >-->

      <button
        type="button"
        class="btn btn-success"
        style="margin-left:16px"
        on:click={() => {
          downloadCSV($tableData, "Devices");
        }}
      >
        <i class="bi bi-table" /> CSV</button
      >
    </div>
  </div>
</div>
<hr />

<!--<div class="table-responsive">-->
<div class="table-responsive table-sm">
  <table class="table table-striped table-hover table-sm">
    <thead>
      <tr>
        <th class="selection">
          <input
            type="checkbox"
            on:click={selectAllRowsInPage}
            checked={isMasterCheckboxSelected}
          />
        </th>

        {#each Object.keys($tableData[0]) as obj}
          {#if allowedData.includes(obj)}
            <Th {handler} orderBy={obj}>{obj.toUpperCase()}</Th>
          {/if}
        {/each}

        <!--{#each allowedData as key}
          <Th {handler} orderBy={key}>{key.toUpperCase()}</Th>
        {/each}-->
      </tr>
      <tr>
        <th class="selection" />

        <!--{#each allowedData as key}
          <ThFilter {handler} filterBy={key} filterId="filter_{key}" />
        {/each}-->

        {#each Object.keys($tableData[0]) as obj}
          {#if allowedData.includes(obj)}
            <ThFilter {handler} filterBy={obj} filterId="filter_{obj}" />
          {/if}
        {/each}

        <!--{#each Object.keys($tableData[0]) as obj}
          {#if allowedData.includes(obj)}

          <ThFilter {handler} filterBy={obj} filterId="filter_{obj}" />

            {#if obj == "id_device"}
              <ThFilter {handler} filterBy={obj} filterId="filter_{obj}" />
              {:else if obj == "app_id"}
              <ThFilter {handler} filterBy={obj} filterId="filter_{obj}" />
            {:else}
              <ThFilter {handler} filterBy={obj} filterId="filter_{obj}" /> 
            {/if}
          {/if}
        {/each}-->
      </tr>
    </thead>
    <tbody class="table-striped table-sm">
      {#each $rows as row}
        <tr class:active={$selected.includes(row.id_device)}>
          <td class="selection">
            <input
              type="checkbox"
              on:click={handler.select(row.id_device)}
              checked={$selected.includes(row.id_device)}
            />
            <!--<input
              type="checkbox"
              on:click={validateCheckBox(row.id_device)}
              checked={checkIfChecked(row.id_device)}
            />-->
          </td>

          {#each Object.keys($tableData[0]) as obj}
            {#if allowedData.includes(obj)}
              {#if obj == "id_device"}
                <td align="center">
                  <a
                    class="nav-link"
                    href={null}
                    on:click={() => {
                      //selectedDeviceId.set([row.id_device]);
                      selectedDevices.set([row]);
                      selectedPage.set(1);
                    }}>{row.id_device}</a
                  >

                  <!--<button
                type="button"
                class="btn btn-link"
                on:click={() => {
                  selectedDeviceId.set([row.id_device]);
                }}
              >
                {row.id_device}
              </button>-->
                </td>
              {:else}
                <td align="center" style="white-space: nowrap"
                  >{row[obj.toString()]}</td
                >
              {/if}
            {/if}
          {/each}
        </tr>
      {/each}
    </tbody>
  </table>
</div>

<br />

<div class="row">
  <div class="col d-flex justify-content-end">
    <RowCount {handler} />
    <div style="width: 12px;" />
    <Pagination {handler} />
  </div>
</div>

<br />

<style>
  thead th.selection {
    width: 48px;
    padding-left: 24px;
  }
  tbody tr {
    transition: all, 0.2s;
  }

  /*tbody tr.active {
    background: #ccd1ff;
  }
  tbody tr.active:hover {
    background: #b19fff;
  }*/

  td.selection {
    padding-left: 24px;
  }
</style>
